import { render, staticRenderFns } from "./resetCompany.vue?vue&type=template&id=4a50f323&scoped=true"
import script from "./resetCompany.vue?vue&type=script&lang=js"
export * from "./resetCompany.vue?vue&type=script&lang=js"
import style0 from "./resetCompany.vue?vue&type=style&index=0&id=4a50f323&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a50f323",
  null
  
)

export default component.exports